import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { HorizontalBarChart } from '@fluentui/react-charting';

/**
 * Estimation Meter implements a singular HorizontalBarChart component from fluent-ui/react-charting for the campaign creation ad group audience & targets view
 */

export const EstimationMeter = (props) => {
  const { low, high } = props;

  const [estimationLow, setEstimationLow] = useState(0);
  const [estimationHigh, setEstimationHigh] = useState(0);

  const getData = (valLow, valHigh) => [
    {
      chartData: [
        {
          horizontalBarChartdata: { x: valLow, y: valHigh },
          color: '#D13438',
        },
      ],
    },
  ];

  useEffect(() => {
    setEstimationLow(low);

    if (!props.high) { // if no high value provided, set high val equal to low (will render a solid horizontal bar chart)
      setEstimationHigh(low);
    } else {
      setEstimationHigh(high);
    }
  }, [high, low, props.high]);

  const getHorizontalChartStyles = () => ({
    chart: { height: 24, margin: 'none' },
    items: { margin: 'none', height: 24 },
    chartTitle: { display: 'none' },
    root: { width: 302 },
  });

  return (
    <div className="estimation-meter">
      <HorizontalBarChart
        data={getData(estimationLow, estimationHigh)}
        barHeight={24}
        hideTooltip
        hideLabels
        styles={getHorizontalChartStyles()}
      />
    </div>
  );
};

EstimationMeter.propTypes = {
  low: PropTypes.number.isRequired,
  high: PropTypes.number,
};

EstimationMeter.defaultProps = {
  high: null,
};
